import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Button, Stack } from "react-bootstrap";
import { PopoverWrap } from "../TooltipLink";
import syncUserConfiguration from "../../utils/AppointmentScheduler/syncUserConfiguration";
const SiteSwitch = () => {
    const { t } = useTranslation(["common"]);
    const [workSite, setWorkSite] = useState(
        localStorage.getItem("work_site") || "",
    );
    return (
        <PopoverWrap
            title={
                <div style={{ width: "18rem" }}>
                    {t("utils:select_work_site")}
                </div>
            }
            placement="left"
        >
            <Stack direction="horizontal" gap={0}>
                <Button
                    variant={
                        localStorage.getItem("work_site") === "omc"
                            ? "outline-success text-light-green fw-bold"
                            : "outline-primary text-white"
                    }
                    className="border border-0"
                    disabled={workSite === "omc"}
                    onClick={() => {
                        setWorkSite("omc");
                        localStorage.setItem("work_site", "omc");
                        syncUserConfiguration(null, "omc", () =>
                            window.location.reload(),
                        );
                    }}
                >
                    {t("common:omc")}
                </Button>
                <Button
                    variant={
                        localStorage.getItem("work_site") === "mmc"
                            ? "outline-success text-light-green fw-bold"
                            : "outline-primary text-white"
                    }
                    className="border border-0"
                    disabled={workSite === "mmc"}
                    onClick={() => {
                        setWorkSite("mmc");
                        localStorage.setItem("work_site", "mmc");
                        syncUserConfiguration(null, "mmc", () =>
                            window.location.reload(),
                        );
                    }}
                >
                    {t("common:mmc")}
                </Button>
            </Stack>
        </PopoverWrap>
    );
};

export default SiteSwitch;
